import React, { Component } from "react";
import PromineoDataGrid from "components/common/controls/grid/PromineoDataGrid";
import { DataGridType } from "components/common/controls/grid/PromineoBaseDataGrid";
import { Column, IDataGridOptions } from "devextreme-react/data-grid";
import { connect } from "react-redux";
import { RootState } from "store/store";
import Invoice from "interfaces/response/Invoice";
import {
  getFullDateFromString,
  getMonthAndDayOrdinalString,
} from "shared/utility/DateTimeUtility";
import InvoiceGridActions from "./InvoiceGridActions";
import Status from "components/common/Status";
import { Variant } from "shared/enums/VariantEnum";
import { Currency } from "shared/enums/CurrencyEnum";
import Subscription from "interfaces/response/Subscription";
import { getFormattedNumber } from "shared/utility/NumberUtility";

interface Props {
  dataSource?: Invoice[];
  currentSubscription?: Subscription | null;
}

interface State {}

export class InvoiceGrid extends Component<Props, State> {
  dataGridRef = React.createRef<DataGridType>();

  PaymentStatusCellRender = ({ data }: { data: Invoice }) => {
    return (
      <Status
        variant={data.isPaid ? Variant.Success : Variant.Danger}
        text={data.isPaid ? "received" : "failed"}
      />
    );
  };

  CalculateAmountCellValue = (data: Invoice) => {
    const currency =
      data.currency === Currency.EUR ? Currency.EUR : Currency.USD;
    return `${getFormattedNumber(data.amount)} ${currency.toLocaleUpperCase()}`;
  };

  handleViewInvoice(invoice: Invoice) {
    window.open(invoice.hostedInvoiceUrl, "_blank");
  }

  calculateDescriptionCellValue(invoice: Invoice) {
    return `Invoice ${getMonthAndDayOrdinalString(
      invoice.periodStart
    )} to ${getMonthAndDayOrdinalString(invoice.periodEnd)}`;
  }

  render() {
    const dataGridOptions: IDataGridOptions = {
      dataSource: this.props.dataSource,
      keyExpr: "id",
    };

    return (
      <div>
        <PromineoDataGrid
          dataGridOptions={dataGridOptions}
          gridRef={this.dataGridRef}
          classNames="max-h-600px"
          enablePagination={true}
        >
          <Column
            dataField="created"
            caption="Date issued"
            cssClass="font-bold"
            calculateCellValue={(data: Invoice) =>
              getFullDateFromString(data.created)
            }
            width="200px"
            alignment="left"
          />
          <Column
            dataField="description"
            caption="Description"
            cssClass="font-bold"
            calculateCellValue={this.calculateDescriptionCellValue}
          />
          <Column
            caption="Plan"
            dataField="licenseSummary"
            cssClass="font-bold"
          />
          <Column
            cssClass="font-bold"
            dataField="amount"
            caption="Amount"
            width="200px"
            alignment="center"
            calculateCellValue={this.CalculateAmountCellValue}
          />
          <Column
            caption="Payment received"
            alignment="center"
            cellRender={this.PaymentStatusCellRender}
            width="150px"
          />
          <Column
            width="100px"
            alignment="center"
            cellRender={(data: any) => (
              <InvoiceGridActions
                onViewClick={() => {
                  this.handleViewInvoice(data.data);
                }}
              />
            )}
          />
        </PromineoDataGrid>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState, props: Props) => {
  return {
    dataSource: state.invoiceData.invoices,
    ...props,
  };
};

export default connect(mapStateToProps)(InvoiceGrid);
